module.exports = __webpack_public_path__ + "b02bda4330b1596132f39369a62d1d10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox-gmail.png
// module id = 162
// module chunks = 0 1